import { useRef, useEffect, useState } from 'react'
import { search } from 'assets/Icons'
import ReactSelect, { Props as SelectProps, components } from 'react-select'
import { useField } from '@unform/core'
import { Icon } from 'assets/index'
import { selectStyles } from './factory'
import {
  Placeholder,
  InputError,
  InputContainer,
} from '../FormCommomStyle/FormCommomStyle'

interface ISelectProps extends SelectProps {
  name: string
  icon?: string
  placeholder?: string
  disabled?: boolean
  value?: any
  small?: boolean
  large?: boolean
  marginRight?: number
  searchbar?: boolean
  onChange?: (_ev: any) => void
  uniqKey?: string
  hasAsterisk?: boolean
  customWith?: number
  dataTestId: string
}

const CustomSearchBar = ({ children, ...props }: any) => {
  return (
    <components.Control {...props}>
      <img className="sb-img" src={search} alt="search icon" />
      {children}
    </components.Control>
  )
}

export default function SelectComponent2(props: ISelectProps) {
  const {
    name,
    placeholder,
    isMulti,
    disabled,
    small,
    value,
    searchbar,
    large,
    uniqKey,
    hasAsterisk,
    onChange,
    customWith,
    dataTestId,
  } = props

  const selectRef: any = useRef<HTMLSelectElement>(null)
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name)
  const [isFocusedOrValid, setIsFocusedOrValid] = useState(!!value)

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (isMulti) {
          if (!ref.state.selectValue) {
            return []
          }
          return ref.state.selectValue.map((option: any) => option.value)
        }
        if (!ref.state.selectValue[0]) {
          return ''
        }
        return ref.state.selectValue[0].value
      },
    })
  }, [fieldName, registerField, isMulti])

  useEffect(() => {
    selectRef.current.value = null
  }, [])

  useEffect(() => {
    setIsFocusedOrValid(!!value)
    if (value) return clearError()
  }, [value])

  const handleFocus = () => setIsFocusedOrValid(true)
  const handleBlur = () => setIsFocusedOrValid(!!value)

  return (
    <InputContainer
      small={small}
      large={large}
      customWith={customWith}
      data-testid={`${dataTestId}`}
    >
      <div className="relative">
        <Placeholder
          isFocusedOrValid={isFocusedOrValid}
          isSearchable={!!searchbar}
          isDisabled={disabled}
        >
          {placeholder}
          {hasAsterisk && <span className="asterisk"> *</span>}
        </Placeholder>

        <ReactSelect
          onFocus={() => {
            handleFocus()
            clearError()
          }}
          onBlur={handleBlur}
          key={uniqKey}
          defaultValue={defaultValue}
          ref={selectRef}
          classNamePrefix="Select"
          placeholder=""
          styles={selectStyles({
            searchbar,
            error: !!error,
          })}
          isDisabled={disabled}
          onChange={(obj: any) => {
            clearError()
            onChange && onChange(obj)
          }}
          isSearchable={searchbar}
          components={searchbar ? { Control: CustomSearchBar } : undefined}
          {...props}
        />
      </div>

      <InputError
        error={error}
        disabled={disabled}
        data-testid={`${dataTestId}-error`}
      >
        <img
          className="img-error"
          src={Icon('alert_circle.svg')}
          alt="error icon"
        />
        {error}
      </InputError>
    </InputContainer>
  )
}
